module.exports = __webpack_public_path__ + "static/media/Insta-image-3.a43465df.jpeg";